import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { Section } from './Section';
import { CtaButton } from './CtaButton';
import { CHECKOUT_URL, PRICE, REGULAR_PRICE, TOTAL_VALUE, SAVINGS } from '../lib/config';
const tomosIncluidos = ['Tomo 1 — El ADN del Evento', 'Tomo 2 — Ingeniería Financiera', 'Tomo 3 — Logística y Producción ★', 'Tomo 4 — Marketing y Ventas', 'Tomo 5 — Proveedores y Contratos', 'Tomo 6 — Manual de Crisis y Protocolo'];
const bonosIncluidos = ['Bono 1 — Brief Premium 15', 'Bono 2 — Mapa Visual de Concepto', 'Bono 3 — Checklist Salón Perfecto (75 puntos)', 'Bono 4 — Kit de Mensajes VIP', 'Bono 5 — Guía Express de Mesas e Invitados'];
const badges = ['Ahorras ' + SAVINGS, 'Pago único', 'Acceso de por vida'];
export function Pricing() {
  return <Section tone="ivory" id="precio" data-id="element-147" data-mp="3h63amgplf4s5">
      <h2 className="text-center font-serif text-[28px] leading-tight sm:text-4xl" data-id="element-148" data-mp="3h97lfwxkcyrs">
        Llévate el sistema completo hoy
      </h2>

      <div className="mx-auto mt-12 max-w-[880px] rounded-card border border-gold bg-white p-7 shadow-lift sm:p-12" data-id="element-149" data-mp="3vzypanw0xl69">
        <div className="text-center" data-id="element-150" data-mp="4s476yxja5c3">
          <h3 className="font-serif text-2xl leading-tight sm:text-[32px]" data-id="element-151" data-mp="4v8j6ih8q5db">
            MASTER PLAN 15 — Edición Completa
          </h3>
          <p className="measure mx-auto mt-3 text-[15px] text-ink-soft" data-id="element-152" data-mp="erv57alaz2gx">
            Todo lo que necesitas para dirigir eventos como profesional y cobrar
            como profesional
          </p>
        </div>

        <div className="mt-10 grid gap-8 border-y border-gold-line py-10 md:grid-cols-2 md:gap-12" data-id="element-153" data-mp="3i78vvye61dz4">
          <ul className="flex flex-col gap-3" data-id="element-154" data-mp="3n63ry2158z16">
            {tomosIncluidos.map(item => <li key={item} className="flex items-start gap-3" data-id="element-155" data-mp="3ry3kvaisqro9">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={2.5} aria-hidden="true" data-id="element-156" data-mp="2uihdtzuaic02" />
                <span className="text-[15px] text-ink-soft" data-id="element-157" data-mp="2zfg3o66x7wsg">{item}</span>
              </li>)}
          </ul>

          <ul className="flex flex-col gap-3" data-id="element-158" data-mp="2mhrtnq9z1k46">
            {bonosIncluidos.map(item => <li key={item} className="flex items-start gap-3" data-id="element-159" data-mp="316obug5qsdii">
                <GiftIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-160" data-mp="3164q0ocz14z7" />
                <span className="text-[15px] text-ink-soft" data-id="element-161" data-mp="28hqse9psoao6">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="mt-10 flex flex-col items-center" data-id="element-162" data-mp="23jz03el8mmjg">
          <p className="text-[13px] uppercase tracking-[0.14em] text-ink-muted" data-id="element-163" data-mp="2ig6iqagzzfwm">
            Valor total: {TOTAL_VALUE}
          </p>
          <p className="mt-2 text-sm text-ink-muted" data-id="element-164" data-mp="2dg228kg3al6e">
            Precio regular:{' '}
            <span className="line-through" data-id="element-165" data-mp="3tuk7dhjkrzdp">{REGULAR_PRICE}</span>
          </p>
          <p className="mt-3 font-serif text-6xl leading-none text-ink sm:text-7xl" data-id="element-166" data-mp="3owin4taexu0n">
            {PRICE}
          </p>

          <ul className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-167" data-mp="a43xsc3ewpg">
            {badges.map(badge => <li key={badge} className="rounded-card border border-gold/40 px-3 py-1.5 text-[11px] uppercase tracking-[0.14em] text-ink-soft" data-id="element-168" data-mp="5ai12fc5om8p">
                {badge}
              </li>)}
          </ul>

          <p className="mt-7 font-serif text-xl italic text-gold-dark sm:text-2xl" data-id="element-169" data-mp="j0vdatw2yn3u">
            Menos de lo que cuesta un centro de mesa.
          </p>
          <p className="mt-2 text-xs text-ink-muted" data-id="element-170" data-mp="nzgb6mnv0up4">
            El cobro se realiza en tu moneda local.
          </p>

          <div className="mt-8 w-full" data-id="element-171" data-mp="a6gyesfgpel9">
            <CtaButton href={CHECKOUT_URL} size="xl" microcopy="Pago seguro · Descarga inmediata · Garantía de 7 días" data-id="element-172" data-mp="e9myfibze9ja">
              Sí, quiero el Master Plan 15
            </CtaButton>
          </div>
        </div>
      </div>
    </Section>;
}